import { render } from "preact";
import { appStore } from "./store.ts";
import { useStore } from "./useStore.ts";
import { SearchView } from "./SearchView.tsx";
import { PlayerView } from "./PlayerView.tsx";
import { HistoryView } from "./HistoryView.tsx";
import { SettingsView } from "./SettingsView.tsx";

function App() {
  const view = useStore(appStore, (s) => s.view);

  return (
    <div
      style={{
        fontFamily: "system-ui",
        padding: "16px",
        maxWidth: "600px",
        margin: "0 auto",
      }}
    >
      <h2 style={{ margin: 0 }}>tvcode.link - Alternative UI</h2>
      <nav
        style={{
          display: "flex",
          gap: "0",
          borderBottom: "1px solid #ddd",
          marginBottom: "16px",
        }}
      >
        {(["search", "player", "history", "settings"] as const).map((tab) => (
            <button
              key={tab}
              onClick={() => appStore.getState().setView(tab)}
              style={{
                flex: 1,
                padding: "10px 0",
                background: "none",
                border: "none",
                borderBottom: view === tab ? "2px solid #333" : "2px solid transparent",
                fontWeight: view === tab ? "bold" : "normal",
                cursor: "pointer",
                fontSize: "14px",
                textTransform: "capitalize",
              }}
            >
              {tab}
            </button>
          ))}
      </nav>

      <div style={{ display: view === "search" ? "block" : "none" }}>
        <SearchView />
      </div>
      {view === "player" && <PlayerView />}
      {view === "history" && <HistoryView />}
      {view === "settings" && (
        <SettingsView onSaved={() => appStore.getState().setView("search")} />
      )}
    </div>
  );
}

render(<App />, document.getElementById("app")!);
